import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import AccountingJournalTable from '@accounting/components/tables/accounting-journal-table/accounting-journal-table.vue';

@Component({
  name: 'bpc-accounting-journals',
  components: {
    'bpc-accounting-journal-table': AccountingJournalTable,
  },
})
export default class AccountingJournals extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
